/* An agent's marketplace listing: read it, and save its category and tagline together. A failed
   save toasts (the query client's default): the section draws no error of its own. */
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import { getListing, marketplaceKeys, saveListing } from "../api/marketplace";

import type { MarketplaceListingSave } from "@/shared/types";

export function useMarketplaceListing(agentId: string, enabled = true) {
  return useQuery({
    queryKey: marketplaceKeys.listing(agentId),
    queryFn: () => getListing(agentId),
    enabled,
  });
}

export function useSaveMarketplaceListing(agentId: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body: MarketplaceListingSave) => saveListing(agentId, body),
    onSuccess: () => qc.invalidateQueries({ queryKey: marketplaceKeys.all }),
  });
}
